/* AvailableDockletsRenderer.js */

"use strict";

class AvailableDockletsRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("available-docklets");
        this._rootElem.component = this._model;
        this._actions = document.createElement("actions");
        this._pin = document.createElement("pin");
        this._partElementsByName = {};
        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve) => {
            this._unregisterListeners();
            this._removeAllIcons();
            this._rootElem.component = null;
            this._rootElem.remove();
            this._rootElem = null;
            this._pin = null;
            this._actions = null;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._availableIconClickHandler = this._availableIconClickHandler.bind(this);
        this._pinIconClickHandler = this._pinIconClickHandler.bind(this);
        this._pin.addEventListener("click", this._pinIconClickHandler);
        this._model.on("Shutdown", () => this._shutdown());
    }

    _unregisterListeners() {
        this._pin.removeEventListener("click", this._pinIconClickHandler);
    }

    _pinIconClickHandler() {
        this._model.pinIconClicked();
    }

    _setPinTitle() {
        if (this._model._state.pinned) {
            this._pin.setAttribute("title", "Unpin the Launch Panel");
        } else {
            this._pin.setAttribute("title", "Pin the Launch Panel");
        }
    }

    /**
     * Handles click events for the disabled part icons
     * @param e
     */
    _availableIconClickHandler(name) {
        this._model.activateDocklet(name);
    }

    /**
     * Adds a disabled part icon to the part menu list
     * @param dockletTypeData
     */
    _addAvailablePartIcon(dockletTypeData) {
        let iconEl = document.createElement("part");
        iconEl.setAttribute("data-id", dockletTypeData.name);
        // iconEl.classList.add("icon");
        // iconEl.classList.add("small");
        // iconEl.classList.add("available");
        let svg = document.createElement("lmrb-icon-gl");
        svg.setAttribute("data-icon", dockletTypeData.iconRepoName);
        svg.setAttribute("data-id", dockletTypeData.name);
        svg.setAttribute("data-lmrb-side", this._model._state._name);

        iconEl.appendChild(svg);
        iconEl.setAttribute("title", "Add " + dockletTypeData.displayName);
        iconEl.addEventListener("click", () => {
            this._availableIconClickHandler(dockletTypeData.name);
        });
        this._partElementsByName[dockletTypeData.name] = iconEl;
        this._rootElem.appendChild(iconEl);
    }

    _setAvailableClass(type, available) {
        let iconEl = this._partElementsByName[type];
        if (available) {
            iconEl.classList.add("available");
        } else {
            iconEl.classList.remove("available");
        }
    }

    /**
     * Removes a disabled part icon from the part menu list
     * @param id
     */
    _removeAvailablePartIcon(type) {
        let iconEl = this._partElementsByName[type];
        if (iconEl) {
            //iconEl.removeEventListener("click",this._availableIconClickHandler, true);
            this._rootElem.removeChild(iconEl);
            delete this._partElementsByName[type];
        }
    }

    _removeAllIcons() {
        Object.keys(this._partElementsByName).forEach((name) => {
            this._removeAvailablePartIcon(name);
        });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     */
    render() {
        if (!this.rootElement.firstChild) {
            this._actions.appendChild(this._pin);
            this._rootElem.appendChild(this._actions);
        }
        this._model.getAvailableParts().forEach((obj) => {
            if (!this._partElementsByName[obj.name]) {
                if (!this._model.getActivePart(name)) {
                    this._addAvailablePartIcon(obj);
                    this._setAvailableClass(obj.name, true);
                }
            }
        });
        Object.keys(this._partElementsByName).forEach((name) => {
            if (!this._model.getAvailablePart(name) || this._model.getActivePart(name)) {
                this._removeAvailablePartIcon(name);
            }
        });
        this._setPinTitle();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = AvailableDockletsRenderer;
